//import { TextField, TextFieldProps } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { PropsWithChildren, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";
import DefaultDateTimePicker from "../../default-date-time-picker/DefaultDateTimePicker";

export type FormDateTimePickerProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rules?: any;
    views?: Array<"day" | "hours" | "minutes" | "month" | "year">;
    minDate?: Date;
    maxDate?: Date;
    minTime?: Date;
    maxTime?: Date;
    minDateTime?: Date;
    maxDateTime?: Date;
    size?: "small" | "medium" | undefined;
} & FormFieldPropsBase;

export default function FormDateTimePicker({
    name,
    id,
    // testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    rules,
    sx,
    disabled,
    views,
    minDate,
    maxDate,
    minTime,
    maxTime,
    minDateTime,
    maxDateTime,
    size
}: PropsWithChildren<FormDateTimePickerProps>): JSX.Element {
    const { control } = useFormContext();



    // function textField(props: TextFieldProps) {

    //     return (
    //         <TextField
    //                 variant="filled"
    //                 id={id}
    //                 data-testid={testId}
    //                 aria-label={ariaLabel ?? undefined}
    //                 //error={props.invalid}
    //                 //helperText={props.invalid ? props.errorMessage : helperText}
    //                 helperText={props.helperText}
    //                 error={props.error}
    //                 InputLabelProps={{
    //                     shrink: true,
    //                 }}
    //                 onBlur={props.onBlur}
    //                 {...props}
    //                 sx={{
    //                     marginTop: 0,
    //                     //width: 1,
    //                     ...sx,
    //                 }}
    //                 size={size}
                    
    //             />
    //     )
    // }



    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={
                ({
                    field: { ref, /*name,*/ value, onChange, onBlur },
                    fieldState: { invalid, /*isTouched, isDirty,*/ error },
                    // formState
                }
                // : {
                //     field: any;
                //     fieldState: any;
                //     formState: any;
                // }
                ) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>

                        <DefaultDateTimePicker
                            disabled={disabled}
                            slotProps={{
                                textField: {
                                   onBlur: onBlur,
                                   error: invalid,
                                   id: id,
                                   variant: 'filled',
                                   "aria-label": (ariaLabel ?? undefined),
                                   helperText: invalid ? error?.message : helperText,
                                   size: size
                                }
                            }}
                            // slots={{
                            //     textField: textField
                            // }}

                            // renderInput={
                            //     (props: TextFieldProps) =>
                            //         <TextField
                            //             variant="filled"
                            //             id={id}
                            //             data-testid={testId}
                            //             aria-label={ariaLabel ?? undefined}
                            //             error={invalid}
                            //             helperText={invalid ? error.message : helperText}
                            //             InputLabelProps={{
                            //                 shrink: true,
                            //             }}
                            //             onBlur={onBlur}
                            //             {...props}
                            //             sx={{
                            //                 marginTop: 0,
                            //                 ...sx
                            //             }}
                            //             size={size}
                            //         />
                            // }
                            label={label}
                            value={value}
                            readOnly={readOnly}
                            onChange={onChange}
                            inputRef={ref}
                            //ref={ref}
                            views={views ?? ["year", "month", "day", "hours", "minutes"]}
                            minDate={minDate}
                            maxDate={maxDate}
                            minTime={minTime}
                            maxTime={maxTime}
                            minDateTime={minDateTime}
                            maxDateTime={maxDateTime}
                            sx={{...sx}}
                        />
                    </LocalizationProvider>
                )
            }
        />
    );
}